import { render, staticRenderFns } from "./CanpayCrewActivePetition.vue?vue&type=template&id=42f1371f&scoped=true&"
import script from "./CanpayCrewActivePetition.vue?vue&type=script&lang=js&"
export * from "./CanpayCrewActivePetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f1371f",
  null
  
)

export default component.exports